"use client";
import { useState } from "react";

export type CusDropDownProps = {
  title: string;
  children: React.ReactNode;
  expand?: boolean;
  idx?: number;
};

export const CustomDropDown: React.FC<CusDropDownProps> = ({
  title,
  expand = true,
  children,
  idx,
  ...props
}) => {
  const [open, setOpen] = useState(expand);
  return (
    <div>
      <div
        onClick={() => setOpen(!open)}
        className={"flex cursor-pointer items-center justify-between border border-bravve-line-100 rounded-xs py-28 px-24 text-bravve-100 bg-bravve-bg-200 mb-8"}
      >
        <span className="firstLetterUppercase text-lg font-medium">
          {title}
        </span>
        <iconpark-icon name={open ? "minus" : "plus"} icon-id={open ? "minusupOrDown" : "plusupOrDown"} size="2rem" />
      </div>
      {open && <div className="mb-32">{children}</div>}
    </div>
  );
};
